// import React from 'react';
// import { Link } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import about from '../assets/images/phone/half-2.png';

export default function AboutTwo() {
  const { t } = useTranslation();

  return (
    <div className="grid md:grid-cols-12 grid-cols-1 items-center gap-6">
      <div className="lg:col-span-5 md:col-span-6 md:order-2 order-1">
        <div className="pt-6 px-6 rounded-2xl bg-red-500/5 dark:bg-indigo-500/10 shadow shadow-red-500/20">
          <img src={about} alt="" />
        </div>
      </div>

      <div className="lg:col-span-7 md:col-span-6 md:order-1 order-2">
        <div className="lg:me-10">
          <h6 className="text-red-500 uppercase text-sm font-bold tracking-wider mb-3">
            {t('aboutTwo.subtitle')}
          </h6>
          <h4 className="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-bold">
            {t('aboutTwo.title')}
          </h4>
          <p className="text-slate-400 max-w-xl">{t('aboutTwo.description')}</p>

          <ul className="list-none text-slate-400 mt-6">
            {(t('aboutTwo.list', { returnObjects: true, defaultValue: [] }) as string[]).map(
              (item: string, index: number) => (
                <li className="mb-1 flex" key={index}>
                  <i className="mdi mdi-check text-red-500 text-xl me-2"></i> {item}
                </li>
              )
            )}
          </ul>
        </div>
      </div>
    </div>
  );
}
